import type { ReactNode } from "react";
import { Input } from "../ui/input";

interface RiskLevelCardProps {
  icon: ReactNode;
  label: string;
  fieldLabel: string;
  value: number;
  onChange: (value: number) => void;
  description: string;
  colorClass: string;
  borderColorClass: string;
  bgClass: string;
}

export function RiskLevelCard({
  icon,
  label,
  fieldLabel,
  value,
  onChange,
  description,
  colorClass,
  borderColorClass,
  bgClass,
}: RiskLevelCardProps) {
  return (
    <div className={`border rounded-lg p-4 space-y-3 ${borderColorClass} ${bgClass}`}>
      <div className={`flex items-center gap-2 ${colorClass}`}>
        {icon}
        <span className="font-bold text-sm">{label}</span>
      </div>
      <div className="space-y-1.5">
        <label className="text-xs text-muted-foreground">{fieldLabel}</label>
        <Input
          type="number"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value) || 0)}
          min={0}
          max={100}
          className="h-9 bg-white"
        />
      </div>
      <p className={`text-xs ${colorClass}`}>{description}</p>
    </div>
  );
}
